import * as React from "react";
import ModalAction, { ModalActionProps } from "./ModalAction";

export default class ModalConfirm extends React.Component<ModalActionProps> {
  render() {
    return (
      <ModalAction
        title={this.props.title}
        cancelButtonLabel={this.props.cancelButtonLabel}
        actionButtonLabel={
          this.props.actionButtonLabel ? this.props.actionButtonLabel : i18n["Global.Confirm"]
        }
        cancel={this.props.cancel}
        action={this.props.action}
        hideCloseIcon={false}
        actionDisabled={this.props.actionDisabled}
        dialogClass={this.props.dialogClass}
        cancelEnabled={this.props.cancelEnabled}
      >
        {this.props.children}
      </ModalAction>
    );
  }
}
